<template>
    <div
        class="loader"
        :class="`loader--${color}`"
    >
        <slot name="loader">
            <i
                class="loader-icon"
                :class="loaderIcon"
            />
        </slot>
    </div>
</template>

<script lang="ts" setup>
import { TButtonColor } from '@/components/RedesignBaseComponents/Buttons/buttons'

withDefaults(
    defineProps<{
        loaderIcon?: string
        color?: TButtonColor
    }>(),
    {
        loaderIcon: 'vc-icon-load',
        color: 'primary'
    }
)
</script>

<style scoped lang="scss">
.loader {
    @apply pointer-events-none;

    .loader-icon {
        @apply inline-block animate-spin transition-all duration-300;
    }

    &--primary {
        @apply text-primary-actions;
    }
    &--secondary {
        @apply text-gray-700;
    }
    &--destructive {
        @apply text-destructive-actions;
    }
}
</style>
